<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-violet-50 to-purple-50 relative overflow-hidden">
    <!-- Decorative blur circles -->
    <div class="absolute top-[-120px] left-[-80px] w-[300px] h-[300px] bg-slate-300/30 rounded-full blur-3xl"></div>
    <div class="absolute bottom-[-100px] right-[-60px] w-[250px] h-[250px] bg-violet-300/30 rounded-full blur-3xl"></div>
    <div class="absolute top-1/2 left-1/3 w-[200px] h-[200px] bg-purple-200/20 rounded-full blur-3xl"></div>

    <!-- Glass card -->
    <div class="relative bg-white/70 backdrop-blur-xl p-8 rounded-2xl shadow-lg border border-white/40 w-full max-w-sm">
      <div class="flex justify-center mb-6">
        <img src="@/assets/prone_logo.jpeg" alt="PRONE LOGO" class="h-24 object-contain" />
      </div>
      <form @submit.prevent="handleLogin" class="space-y-4">
        <input
          v-model="username"
          type="text"
          placeholder="아이디를 입력해주세요"
          required
          class="w-full border border-gray-200 rounded-lg p-2.5 bg-white/60 focus:outline-none focus:border-violet-400 focus:ring-2 focus:ring-violet-100 transition-all"
        />
        <div class="relative">
          <input
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            placeholder="비밀번호를 입력해주세요"
            required
            class="w-full border border-gray-200 rounded-lg p-2.5 pr-10 bg-white/60 focus:outline-none focus:border-violet-400 focus:ring-2 focus:ring-violet-100 transition-all"
          />
          <button
            type="button"
            @click="togglePasswordVisibility"
            class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-violet-500 transition-colors"
            :aria-label="showPassword ? '비밀번호 숨기기' : '비밀번호 표시하기'"
          >
            <span class="text-gray-400 text-sm">
              {{ showPassword ? 'Hide' : 'Show' }}
            </span>
          </button>
        </div>
        <button
          type="submit"
          class="w-full bg-slate-800 text-white py-2.5 rounded-lg hover:bg-slate-900 disabled:bg-gray-300 transition-all shadow-sm"
          :disabled="isLoading"
        >
          {{ isLoading ? '로그인 중...' : '로그인' }}
        </button>
      </form>
      <div v-if="errorMessage" class="mt-4 px-3 py-2 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm text-center">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'

export default {
  name: 'LoginView2',
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()

    const username = ref('')
    const password = ref('')
    const showPassword = ref(false)

    const isLoading = computed(() => store.state.auth.isLoading)
    const errorMessage = ref('')

    onMounted(() => {
      if (route.query.message) {
        errorMessage.value = route.query.message
      }
    })

    const handleLogin = async () => {
      try {
        await store.dispatch('auth/login', {
          username: username.value,
          password: password.value
        })

        const token = localStorage.getItem('access_token')
        if (!token) {
          throw new Error('Token not stored after login')
        }

        // 로그인 완료 후 페이지 이동
        await router.push({ name: 'MainPub' })
      } catch (error) {
        console.error('Login error:', error)
        errorMessage.value = '로그인에 실패했습니다. 아이디와 비밀번호를 확인해주세요.'
      }
    }

    const togglePasswordVisibility = () => {
      showPassword.value = !showPassword.value
    }

    return {
      username,
      password,
      showPassword,
      isLoading,
      errorMessage,
      handleLogin,
      togglePasswordVisibility
    }
  }
}
</script>
